import styled from 'styled-components';

const ConfirmationModalWrapper = styled.div`
  width: 368px;
`;

export default ConfirmationModalWrapper;
